import React from 'react'
import AboutPascal from '../components/componentshome/AboutPascal'

function YourRealtor() {
  return (
    <div>
        <AboutPascal />
    </div>
  )
}

export default YourRealtor